import { useEffect, useState } from 'react';
import { VendorWarehouseTable } from '../shared/vendor-warehouse-table';
import Modal from '../shared/modal';

export function VendorInventoryManagement({
  data,
  isDialogOpen,
  setOpenDialog,
}) {
  const [vendorInventory, setVendorInventory] = useState(data);

  useEffect(() => {
    setVendorInventory(data);
  }, [data]);

  const handleOpen = () => {
    setOpenDialog((prev) => ({
      ...prev,
      isDialogOpen: false,
    }));
  };

  return (
    <Modal
      open={isDialogOpen}
      setOpen={() => handleOpen()}
      title={'Vendor Inventory'}
      allowBackdropClose
    >
      {data.length ? (
        <VendorWarehouseTable data={vendorInventory} />
      ) : (
        'No data'
      )}
    </Modal>
  );
}
